import { render, staticRenderFns } from "./userPlan.vue?vue&type=template&id=a9d2ded4&scoped=true&"
import script from "./userPlan.vue?vue&type=script&lang=ts&"
export * from "./userPlan.vue?vue&type=script&lang=ts&"
import style0 from "./userPlan.vue?vue&type=style&index=0&id=a9d2ded4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d2ded4",
  null
  
)

export default component.exports